import React from "react";
import {
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectArrayInput,
  SelectInput
} from "react-admin";
import { useFormState, useField } from "react-final-form";

interface ICustomAcademicTermInput {
  parentCallback?: (x: number) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
  multipleSelection?: boolean;
}

const AcademicTermInput = ({
  isRequired,
  isDisabled,
  parentCallback,
  className,
  multipleSelection
}: ICustomAcademicTermInput) => {
  const { values } = useFormState();
  const date = useField("date");

  return multipleSelection ? (
    <ReferenceArrayInput
      className={className}
      label="Academic Term"
      source="academicTermIds"
      reference="academicTerms"
      filter={{
        AcademicYearId: values.academicYearId
          ? parseInt(values.academicYearId)
          : 0,
      }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        date && date.input.onChange("");
      }}
      validate={isRequired ? required() : undefined}
      disabled={isDisabled}
    >
      <SelectArrayInput
        optionText="name"
        optionId="id"
        options={{
          MenuProps: {
            PaperProps: {
              style: {
                minWidth: '910px',
                width: 'auto',
              },
            },
          },
        }}
      />
    </ReferenceArrayInput>
  ) : (
    <ReferenceInput
      className={className}
      label="Academic Term"
      source="academicTermId"
      reference="academicTerms"
      filter={{
        AcademicYearId: values.academicYearId
          ? parseInt(values.academicYearId)
          : 0,
      }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        date && date.input.onChange("");
      }}
      validate={isRequired ? required() : undefined}
      disabled={isDisabled}
    >
      <SelectInput optionText="name" optionId="id" />
    </ReferenceInput>
  );
};

export default AcademicTermInput;
